export default "__VITE_ASSET__4be768d2__"